const frontPageControllers = angular.module('frontpage.module', ['ui.router']);

frontPageControllers.controller('frontPageController', function(
  $element,
  $rootScope,
  userViewService
) {
  userViewService.setView('frontpage');

  updateHeight();

  $rootScope.$on('window-resize', function() {
    updateHeight();
  });

  function updateHeight() {
    $element.height(window.innerHeight - 200 + 'px');
  }
});
